export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

const restoreFaviconOnVisible = () => {
  if (document.visibilityState === 'visible') {
    const favicons = document.querySelectorAll('.favicon');
    favicons.forEach(favicon => {
      const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
      favicon.href = oldFileName;
    });
  }
};

export const initFaviconSwitcher = () => {
  // Reinvocado a cada salvamento de preferência (OMNIHITV2-405). Usa handler
  // nomeado e remove antes de adicionar para permanecer idempotente — evita
  // vazar listeners de visibilitychange a cada reconfiguração.
  document.removeEventListener('visibilitychange', restoreFaviconOnVisible);
  document.addEventListener('visibilitychange', restoreFaviconOnVisible);
};
